import type { PostAnalyticsFN } from '../../common/Analytics';
import { CHATBOT_WEBHOOK, type AnalyticsEvent } from '../../common/Analytics';
import type { default as DB } from '../../db/DB';
import type { ZoomWebhookEvent } from '../../ReplicantChatbot';
import type { Replicant } from '../../ReplicantConfig';
import type { APIAccessInterface, PushDocsToIndexFn } from '../ServerReplicant';
import { executeOnWebhook } from './executeOnWebhook';

export class ZoomWebhookHandler<T extends Replicant> {
    constructor(
        private opts: {
            apiAccess: APIAccessInterface<T>;
            db: DB<any>;
            pushDocsToIndex: PushDocsToIndexFn;
            sendAnalyticsEvents: PostAnalyticsFN;
        },
    ) {}

    async handleEvent(webhookEvent: ZoomWebhookEvent): Promise<void> {
        if (webhookEvent.event !== 'app_deauthorized') {
            throw Error('Invalid Zoom webhook event: ' + JSON.stringify(webhookEvent));
        }

        const onWebhookHandler = this.opts.apiAccess.config.chatbot?.events?.onWebhook;
        if (!onWebhookHandler) {
            return;
        }

        const userId = webhookEvent.payload.user_id;

        await this.opts.sendAnalyticsEvents([generateWebhookAnalyticEvent(webhookEvent)]);

        const { newIndexDoc } = await executeOnWebhook(userId, [webhookEvent], this.opts.apiAccess, this.opts.db, {
            createUserIfNotFound: false,
        });

        if (newIndexDoc) {
            await this.opts.pushDocsToIndex({ [userId]: newIndexDoc });
        }
    }
}

function generateWebhookAnalyticEvent(webhookEvent: ZoomWebhookEvent): AnalyticsEvent {
    return {
        user_id: webhookEvent.payload.user_id,
        event_type: CHATBOT_WEBHOOK,
        event_properties: { webhookEventType: webhookEvent.event } as any,
    };
}
